import { ImpersonatorBar } from '@components/impersonate/bar';
import NavigationBar from '@components/ui/navigation-bar';
import { useIsImpersonator } from '@hooks/auth';
import { fixedAtTopCss } from '@styles/css';
import { FunctionComponent, useRef } from 'react';
import styled, { css } from 'styled-components';
import BaseLayout from '../base';

type MainLayoutProps = {
  showNavigationBar?: boolean;
  paddingTop?: number;
};

const BaseLayoutStyled = styled(BaseLayout)<MainLayoutProps>`
  ${({ paddingTop }) =>
    paddingTop &&
    css`
      margin-top: ${paddingTop}px;
    `}
`;

const BarContainer = styled.div`
  ${fixedAtTopCss}
`;

const MainLayout: FunctionComponent<MainLayoutProps> = ({
  children,
  showNavigationBar = true,
}) => {
  const barRef = useRef<HTMLDivElement | null>(null);
  const isImpersonator = useIsImpersonator();

  return (
    <BaseLayoutStyled paddingTop={barRef.current?.clientHeight}>
      <BarContainer ref={barRef}>
        {isImpersonator && <ImpersonatorBar />}
        {showNavigationBar && <NavigationBar />}
      </BarContainer>
      {children}
    </BaseLayoutStyled>
  );
};

export default MainLayout;
